import { SERVICEAPP_BRAND } from '../../share/serviceappBrand';
import { isToolsAndBubblesStockLogo, type ResolvedCompanyBranding } from '../../utils/companyBranding';

/** Default ServiceApp mark when tenant has no custom logo in company profile. */
export const SAAS_DEFAULT_LOGO_URL = SERVICEAPP_BRAND.logo;

export function resolveSaasLogoUrl(logoUrl?: string | null): string {
  const trimmed = String(logoUrl ?? '').trim();
  if (!trimmed || isToolsAndBubblesStockLogo(trimmed)) return SAAS_DEFAULT_LOGO_URL;
  return trimmed;
}

export function resolveSaasLogoFromBranding(branding: Pick<ResolvedCompanyBranding, 'logoUrl'>): string {
  return resolveSaasLogoUrl(branding.logoUrl);
}

/** True when the tenant uploaded a company logo (not the platform default mark). */
export function hasCustomSaasLogo(branding: Pick<ResolvedCompanyBranding, 'logoUrl'>): boolean {
  const url = String(branding.logoUrl ?? '').trim();
  if (!url || isToolsAndBubblesStockLogo(url)) return false;
  if (url === SAAS_DEFAULT_LOGO_URL || url.includes('serviceapp-logo')) return false;
  return true;
}
